import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NxtTopBar from '../../../basic/nxt-top-bar';
import IxBottomNav from '../../../basic/ix-bottom-nav';
import {
  yellowBaseColor,
  blackLikeBackground
} from '../../../../constants/theme-colors';
import { setLogout } from '../../home/appStateSlice';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { Avatar, withStyles, Menu, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  bottomNav: {
    bottom: '0',
    position: 'fixed',
    width: '100%',
    marginLeft: '0em',

    zIndex: theme.zIndex.bottomNav
  },
  avatarWrapper: {
    //backgroundColor: yellowBaseColor,
    color: blackLikeBackground,
    paddingTop: theme.spacing(2),
    //borderBottom: '1px solid RGB(225,225,225)',
    marginTop: '2rem'
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatarStyle: {
    height: '80px',
    width: '80px',
    marginTop: '1rem',
    background: 'rgb(0 0 0 / 8%)'
  },
  personIcon: {
    fontSize: '2.5em',
    color: '#A6ACAF'
  },
  accountInfo: {
    textAlign: 'center'
  },
  optionHeader: {
    color: 'black',
    marginLeft: '1rem',
    fontWeight: 600
  },
  accountOptions: {
    background: 'rgb(0 0 0 / 8%)',
    borderBottom: '1px solid rgb(0 0 0 / 10%)',
    borderTop: '1px solid rgb(0 0 0 / 10%)',
    height: '4rem',
    '& .MuiTypography-body1': {
      fontSize: '1rem',
      fontWeight: 400,
      color: '#424949'
    }
  },
  optionArrowIcon: {
    fontSize: '1rem',
    color: '#A6ACAF'
  },
  userName: {
    fontSize: '1.8rem'
  },
  userEmail: {
    fontSize: '1.1rem',
    fontWeight: 400
  },
  optionListContainer: {
    height: '85vh',
    overflowY: 'auto'
  }
}));

const TakeoutCustomerAccount = props => {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const { history } = props;
  const { t, i18n } = useTranslation(['common']);
  const dispatch = useDispatch();
  const loggedInUser =  useSelector((state) => state.appState.registeredUser.data);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  return (
    <div>
      <Box className={classes.bottomNav} component='span'>
        <IxBottomNav props={props}></IxBottomNav>
      </Box>

      <NxtTopBar children={t('myAccount')} />
      <Box className={classes.optionListContainer}>
        <List className={classes.avatarWrapper}>
          <ListItem className={classes.avatarContainer}>
            <Avatar className={classes.avatarStyle}>
              <PersonOutlineIcon className={classes.personIcon} />
            </Avatar>
          </ListItem>

          <ListItem className={classes.accountInfo}>
            <ListItemText
              classes={{
                primary: classes.userName,
                secondary: classes.userEmail
              }}
              primary={(loggedInUser?.firstName || loggedInUser?.lastName) && `${ loggedInUser?.firstName ?? ''} ${loggedInUser?.lastName ?? ''}`}
              secondary={loggedInUser?.email}
            />
          </ListItem>

          <p className={classes.optionHeader}>{t('manageAccount')}</p>
          <ListItem
            button
            // selected={selectedIndex === 0}
            onClick={() => history.push('/profile')}
            className={classes.accountOptions}
          >
            <ListItemText primary={t('User Profile')} />
            <ArrowForwardIosIcon className={classes.optionArrowIcon} />
          </ListItem>
          <ListItem
            button
            // selected={selectedIndex === 1}
            onClick={() => history.push('/change-password')}
            className={classes.accountOptions}
          >
            <ListItemText primary={t('Change Password')} />
            <ArrowForwardIosIcon className={classes.optionArrowIcon} />
          </ListItem>
          <ListItem
            button
            disabled
            // selected={selectedIndex === 1}
            onClick={event => handleListItemClick(event, 1)}
            className={classes.accountOptions}
          >
            <ListItemText primary={t('Cancel Account')} />
            <ArrowForwardIosIcon className={classes.optionArrowIcon} />
          </ListItem>

          <p className={classes.optionHeader}>{t('Activity')}</p>
          <ListItem
            button
            onClick={ () => {
              dispatch(setLogout())
              history.push(`/pickup-time-selection`)
            }}
            className={classes.accountOptions}
          >
            <ListItemText primary= {t('logout')} />
            <ArrowForwardIosIcon className={classes.optionArrowIcon} />
          </ListItem>
        </List>
      </Box>
    </div>
  );
};

export default TakeoutCustomerAccount;
